// /* eslint-disable react/jsx-no-target-blank */
// import React from 'react'
// import { useIntl } from 'react-intl'
// import { KTIcon } from '../../../../helpers'
// import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub'
// import { SidebarMenuItem } from './SidebarMenuItem'
// import { useAuth } from '../../../../../app/modules/auth'

// const SidebarMenuMain = () => {
//   const intl = useIntl()
//   const { auth } = useAuth()
//   const hideSideBar = auth?.data?.userType === 'FRANCHISE' || false

//   return (
//     <>
//       <SidebarMenuItem
//         to='/dashboard'
//         icon='element-11'
//         title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
//         fontIcon='bi-app-indicator'
//       />
//       <SidebarMenuItem to='/apps/stock' icon='parcel' title='Lifecycle' fontIcon='bi-layers' />
//       <SidebarMenuItem
//         to='/apps/mass-balance'
//         icon='parcel'
//         title='Mass Balance'
//         fontIcon='bi-layers'
//       />

//       <div className='menu-item'>
//         <div className='menu-content pt-8 pb-2'>
//           <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
//         </div>
//       </div>

//       <SidebarMenuItem
//         to='/apps/userManagement'
//         icon='abstract-28'
//         title='User Management'
//         fontIcon='bi-layers'
//       />

//       {/* userManagement
//       facility-master */}

//       {!hideSideBar && (
//         <SidebarMenuItem
//           to='/apps/facility-master'
//           icon='grid-frame'
//           title='Franchise '
//           fontIcon='bi-layers'
//         />
//       )}
//       <SidebarMenuItem
//         to='/apps/depositer'
//         icon='switch'
//         title='Waste Picker'
//         fontIcon='bi-layers'
//       />
//       <SidebarMenuItem
//         to='/apps/logistics'
//         icon='switch'
//         title='Logistics'
//         fontIcon='bi-layers'
//       />
//       <SidebarMenuItem
//         to='/apps/transactions'
//         icon='row-horizontal'
//         title='Transaction'
//         fontIcon='bi-layers'
//       />
//       <SidebarMenuItem
//         to='/apps/collection-point'
//         icon='row-horizontal'
//         title='Aggregator'
//         fontIcon='bi-layers'
//       />
//       <SidebarMenuItem
//         to='/apps/recycler'
//         icon='abstract-28'
//         title='Recycler'
//         fontIcon='bi-layers'
//       />

//       {/* <SidebarMenuItem to='/apps/rider' icon='abstract-28' title='Rider' fontIcon='bi-layers' /> */}
//       {/* <SidebarMenuItem
//         to='/apps/collect-orders'
//         icon='element-11'
//         title='Collect Orders'
//         fontIcon='bi-layers'
//       />
//       <SidebarMenuItem
//         to='/apps/processing-record'
//         icon='element-11'
//         title='Processing Record'
//         fontIcon='bi-layers'
//       />
//       <SidebarMenuItem
//         to='/apps/supply-orders'
//         icon='maximize'
//         title='Supply Orders'
//         fontIcon='bi-layers'
//       /> */}
//       {/* {!hideSideBar && (
//         <SidebarMenuItemWithSub
//           to='/apps/settings'
//           title='Settings'
//           fontIcon='bi-chat-left'
//           icon='message-text-2'
//         >
//           <SidebarMenuItem to='/apps/settings/content' title='Content' hasBullet={true} />
//           <SidebarMenuItem to='/apps/settings/category' title='Category' hasBullet={true} />
//           <SidebarMenuItem to='/apps/settings/sub-category' title='Sub Category' hasBullet={true} />
//           <SidebarMenuItem to='/apps/settings/pricing' title='Pricing' hasBullet={true} />
//           <SidebarMenuItem to='/apps/settings/incentive' title='Incentive' hasBullet={true} />
//           <SidebarMenuItem
//             to='/apps/settings/processing-routes'
//             title='Processing Routes'
//             hasBullet={true}
//           />
//         </SidebarMenuItemWithSub>
//       )} */}

//       {!hideSideBar && (
//         <SidebarMenuItem
//           to='/apps/settings'
//           title='Settings'
//           fontIcon='bi-chat-left'
//           icon='message-text-2'
//         />
//       )}

//       {/* <div className='menu-item'>
//         <a
//           target='_blank'
//           className='menu-link'
//           href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
//         >
//           <span className='menu-icon'>
//             <KTIcon iconName='code' className='fs-2' />
//           </span>
//           <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
//         </a>
//       </div> */}
//     </>
//   )
// }

// export { SidebarMenuMain }

/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const {auth} = useAuth()
  const hideSideBar = auth?.data?.userType === 'FRANCHISE'
  const isRecycler = auth?.data?.userType === 'RECYCLER'

  // console.log((auth as any).data.userRole.role);

  return (
    <>
      {!isRecycler && (
        <>
          <SidebarMenuItem
            to='/dashboard'
            icon='/media/sidebar/icons8-dashboard-64.png'
            title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
            fontIcon='bi-app-indicator'
          />
          {/* <SidebarMenuItem to='/apps/stock' icon='parcel' title='Lifecycle' fontIcon='bi-layers' /> */}
          <SidebarMenuItem
            to='/apps/reports'
            icon='/media/sidebar/icons8-report-64.png'
            title='Reports'
            fontIcon='bi-layers'
          />
          {/* <SidebarMenuItem
            to='/apps/mass-balance'
            icon='parcel'
            title='Mass Balance'
            fontIcon='bi-layers'
          /> */}
        </>
      )}

      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Marketplace</span>
        </div>
      </div>

      {/* Show User Management and Transaction for all user types */}

      {/* If the user is a 'RECYCLER', show only User Management and Transactions */}
      {!isRecycler && (
        <>
          {/* <SidebarMenuItem
            to='/apps/app-users'
            icon='grid-frame'
            title='Field Executive'
            fontIcon='bi-layers'
          /> */}

          {/* <SidebarMenuItem
            to='/apps/facility-master'
            icon='grid-frame'
            title='Franchise'
            fontIcon='bi-layers'
          /> */}

          {/* 
          <SidebarMenuItem
            to='/apps/recycler'
            icon='abstract-28'
            title='Recycler'
            fontIcon='bi-layers'
          /> */}

          {/* <SidebarMenuItem
            to='/apps/collection-point'
            icon='row-horizontal'
            title='Aggregator'
            fontIcon='bi-layers'
          /> */}

          {/* 
          <SidebarMenuItem
            to='/apps/depositer'
            icon='switch'
            title='Waste Picker'
            fontIcon='bi-layers'
          /> */}

          {/* <SidebarMenuItem
            to='/apps/logistics'
            icon='switch'
            title='Logistics'
            fontIcon='bi-layers'
          /> */}
        </>
      )}

      {isRecycler && (
        <>
          <SidebarMenuItem
            to='/apps/transactions'
            icon='row-horizontal'
            title='Transaction'
            fontIcon='bi-layers'
          />
        </>
      )}

      {/* {isRecycler && (
        <>
          <SidebarMenuItem
            to='/apps/userManagement'
            icon='abstract-28'
            title='User Management'
            fontIcon='bi-layers'
          />
        </>
      )} */}

      {/* {!isRecycler && (
        <>

          <SidebarMenuItem
            to='/apps/settings'
            title='Settings'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          />
          <SidebarMenuItem
            to='/apps/business'
            title='Business'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          />
          <SidebarMenuItem
            to='/apps/finance'
            title='Finance'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          />
          <SidebarMenuItem
            to='/apps/logic'
            title='Logistics'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          />
          <SidebarMenuItem
            to='/apps/purchase'
            title='Purchase'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          />
          <SidebarMenuItem
            to='/apps/sales'
            title='Sales'
            fontIcon='bi-chat-left'
            icon='message-text-2'
          />
        </>
      )} */}

      {!isRecycler && (
        <>
          {(() => {
            // Debug log to see what we're working with
            // console.log("Auth data:", auth?.data);
            // console.log("UserRole:", auth?.data?.userRole);

            // Check if we have proper role data
            const hasRoleData =
              auth &&
              auth.data &&
              auth.data.userRole &&
              Array.isArray(auth.data.userRole.role) &&
              auth.data.userRole.role.length > 0

            // console.log("Has role data:", hasRoleData);

            // Function to check for a specific role
            const hasRole = (roleType) => {
              if (!hasRoleData) return false
              const result = auth.data.userRole.role.some((role) => role?.type === roleType)
              // console.log(`Has ${roleType} role:`, result, auth.data.userRole.role);
              return result
            }

            // If we have role data, use it to filter menu items
            if (hasRoleData) {
              return (
                <>
                  {hasRole('SETTINGS') && (
                    <SidebarMenuItem
                      to='/apps/settings'
                      title='Settings'
                      fontIcon='bi-chat-left'
                      icon='/media/sidebar/icons8-setting-64.png'
                    />
                  )}

                  {hasRole('BUSINESS') && (
                    <SidebarMenuItem
                      to='/apps/business'
                      title='Business'
                      fontIcon='bi-chat-left'
                      icon='/media/sidebar/bsuiness.png'
                    />
                  )}

                  {hasRole('FINANCE') && (
                    <SidebarMenuItem
                      to='/apps/finance'
                      title='Finance'
                      fontIcon='bi-chat-left'
                      icon='/media/sidebar/finance.png'
                    />
                  )}

                  {hasRole('LOGISTIC') && (
                    <SidebarMenuItem
                      to='/apps/logic'
                      title='Logistics'
                      fontIcon='bi-chat-left'
                      icon='/media/sidebar/logistiocs.png'
                    />
                  )}

                  {hasRole('PURCHASE') && (
                    <SidebarMenuItem
                      to='/apps/purchase'
                      title='Purchase'
                      fontIcon='bi-chat-left'
                      icon='/media/sidebar/purchase.png'
                    />
                  )}

                  {hasRole('SALE') && (
                    <SidebarMenuItem
                      to='/apps/sales'
                      title='Sales'
                      fontIcon='bi-chat-left'
                      icon='/media/sidebar/sale.png'
                    />
                  )}

                  <SidebarMenuItem
                    to='/apps/logs'
                    title='Logs'
                    fontIcon='bi-chat-left'
                    icon='/media/sidebar/icons8-log-64.png'
                  />
                  <SidebarMenuItem
                    to='/apps/inspection-logs'
                    title='Inspection Logs'
                    fontIcon='bi-chat-left'
                    icon='/media/sidebar/inspection.png'
                  />
                  <SidebarMenuItem
                    to='/apps/gst-logs'
                    title='GST Logs'
                    fontIcon='bi-chat-left'
                    icon='/media/sidebar/gst.png'
                  />
                  <SidebarMenuItem
                    to='/apps/kyc-logs'
                    title='KYC Logs'
                    fontIcon='bi-chat-left'
                    icon='/media/sidebar/gst.png'
                  />

                  {/* <SidebarMenuItem
                    to='/apps/textile'
                    title='Textile'
                    fontIcon='bi-chat-left'
                    icon='/media/sidebar/textile.png'
                  /> */}
                </>
              )
            }

            // If no role data, show all menu items
            // console.log("No role data, showing all menu items");
            return (
              <>
                <SidebarMenuItem
                  to='/apps/settings'
                  title='Settings'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/icons8-setting-64.png'
                />
                <SidebarMenuItem
                  to='/apps/business'
                  title='Business'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/bsuiness.png'
                />
                <SidebarMenuItem
                  to='/apps/finance'
                  title='Finance'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/finance.png'
                />
                <SidebarMenuItem
                  to='/apps/logic'
                  title='Logistics'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/logistiocs.png'
                />
                <SidebarMenuItem
                  to='/apps/purchase'
                  title='Purchase'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/purchase.png'
                />
                <SidebarMenuItem
                  to='/apps/sales'
                  title='Sales'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/sale.png'
                />
                <SidebarMenuItem
                  to='/apps/logs'
                  title='Logs'
                  fontIcon='bi-chat-left'
                  icon='/media/sidebar/icons8-log-64.png'
                />
              </>
            )
          })()}
        </>
      )}

      {/* If the user is not a 'RECYCLER' or 'FRANCHISE', show settings */}
      {/* {!hideSideBar && (
        <SidebarMenuItem
          to='/apps/settings'
          title='Settings'
          fontIcon='bi-chat-left'
          icon='message-text-2'
        />
      )} */}

      {/* Optional additional section (like changelog) */}
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTIcon iconName='code' className='fs-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}

export {SidebarMenuMain}
